/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';

    function updateSlideAccessibility(selectedIndex) {
      $slideshowClassicEl.find('.gallery-cell').each(function(index) {
        const isSelected = index === selectedIndex;
        const $slide = $(this);

        $slide.attr('aria-hidden', isSelected ? 'false' : 'true');

        $slide.find(focusableSelector).each(function() {
          if (!isSelected) {
            if (!this.hasAttribute('data-slideshow-tabindex')) {
              this.setAttribute('data-slideshow-tabindex', this.getAttribute('tabindex') || '');
            }
            this.setAttribute('tabindex', '-1');
          } else if (this.hasAttribute('data-slideshow-tabindex')) {
            const originalTabindex = this.getAttribute('data-slideshow-tabindex');
            if (originalTabindex === '') {
              this.removeAttribute('tabindex');
            } else {
              this.setAttribute('tabindex', originalTabindex);
            }
            this.removeAttribute('data-slideshow-tabindex');
          }
        });
      });
    }

    // Keep controls in visually hidden slides out of the keyboard tab order.
    $slideshowClassicEl.on('ready.flickity change.flickity select.flickity', function(event, selectedIndex) {
      updateSlideAccessibility(typeof selectedIndex === 'number' ? selectedIndex : 0);
    });

    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });

    const slideshowInstance = $slideshowClassicEl.data('flickity');
    updateSlideAccessibility(slideshowInstance ? slideshowInstance.selectedIndex : 0);

    // Resize flickity when the slider is settled
    $slideshowClassicEl.on( 'settle.flickity', function() {
      $slideshowClassicEl.flickity('resize');
    })

  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;
